import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';
import { Box, Stack, ShortText } from 'src/viewLayer/components/DesignSystem';

import TextWithPartialCustomStyling from 'src/viewLayer/components/shared/TextWithPartialCustomStyling';
import { t } from 'src/viewLayer/helpers/translations';
import { buildValidFlowPath } from 'src/viewLayer/helpers/pathHelpers';
import { FLOW_ID_WITHOUT_L2 } from 'src/dataLayer/env';
import { LinkProps, PolishInformationBoxProps } from './types';
import { InformationBoxContainer, InformationBoxLink } from './index.styled';

const GermanLink: React.FC<LinkProps> = ({ children }): JSX.Element => {
  const pathParameters = useParams();
  const [queryParams,] = useSearchParams();
  const href = buildValidFlowPath({
    ...pathParameters,
    flowId: FLOW_ID_WITHOUT_L2,
    nodeNumber: 0,
    locale: 'de',
    queryParams
  });

  return (
    <InformationBoxLink href={ href } color="highlight" underlined={ false } weight="strong">
      { children }
    </InformationBoxLink>
  );
};

const EnglishLink: React.FC<LinkProps> = ({ children }): JSX.Element => {
  const pathParameters = useParams();
  const [queryParams,] = useSearchParams();
  const href = buildValidFlowPath({
    ...pathParameters, flowId: FLOW_ID_WITHOUT_L2, nodeNumber: 0, locale: 'en_GB', queryParams
  });

  return (
    <InformationBoxLink href={ href } color="highlight" underlined={ false } weight="strong">
      { children }
    </InformationBoxLink>
  );
};

export const PolishInformationBox = ({
  title,
  infoBoxContentKeyPart1,
  infoBoxContentKeyPart2
}: PolishInformationBoxProps): JSX.Element => (
  <InformationBoxContainer className="InformationBox">
    <Stack alignItems="leading" gap={ tokens.size.space.xxsmall }>
      <ShortText weight="strong">{ title }</ShortText>
      <Box>
        {
          TextWithPartialCustomStyling({
            translationText: t(infoBoxContentKeyPart1),
            customStyledComponents: [GermanLink]
          }).map((TextPiece: JSX.Element) => TextPiece)
        }
        {
          TextWithPartialCustomStyling({
            translationText: t(infoBoxContentKeyPart2),
            customStyledComponents: [EnglishLink]
          }).map((TextPiece: JSX.Element) => TextPiece)
        }
      </Box>
    </Stack>
  </InformationBoxContainer>
);
